/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PraticaAttributiBulkUpdateForm { 
    pratica?: { [key: string]: any; };
    anagrafica?: { [key: string]: any; };
    componente?: { [key: string]: { [key: string]: any; }; };
    modes_pratica?: { [key: string]: PraticaAttributiBulkUpdateFormModesPraticaEnum; };
    modes_componente?: { [key: string]: { [key: string]: PraticaAttributiBulkUpdateFormModesComponenteEnum; }; };
    version: number;
}
export enum PraticaAttributiBulkUpdateFormModesPraticaEnum {
    PRESA_IN_CARICO = 'PRESA_IN_CARICO',
    AGGIORNA = 'AGGIORNA',
    SOVRASCRIVI_ORIGINALE = 'SOVRASCRIVI_ORIGINALE'
};
export enum PraticaAttributiBulkUpdateFormModesComponenteEnum {
    PRESA_IN_CARICO = 'PRESA_IN_CARICO',
    AGGIORNA = 'AGGIORNA',
    SOVRASCRIVI_ORIGINALE = 'SOVRASCRIVI_ORIGINALE'
};



